'use strict'

import moment from 'moment'

import { dateFormatter } from '../../functions'
import { callSalesApi } from '../call-api/sales'

export const STATUS = {
  CANCELADO: {
    id: 1,
    description: 'Cancelado',
  },
  CONCRETIZADO: {
    id: 0,
    description: 'Concretizado'
  },
  TODOS: {
    id: 2,
    description: 'Todos'
  }
}

export const DATES = {
  INICIAL: {
    id: 1,
    description: 'Data inicial'
  },
  FINAL: {
    id: 2,
    description: 'Data final'
  }
}

export function onClassChange(classAttrValue) {
  const classList = classAttrValue.split(' ')
  const cssAttributeToChange = document.querySelectorAll('.class-observer')

  if (classList.includes('sidebar-show')) {
    this.applyStyle(cssAttributeToChange, 100)
  } else if (window.matchMedia('(min-width: 768px)').matches) {
    this.applyStyle(cssAttributeToChange, 33.33333)
  }
}

export function applyStyle(attribute, percentage) {
  attribute.forEach((element) => {
    element.style.maxWidth = `${percentage}%`
    element.style.flex = `0 0 ${percentage}%`
  })
}

export function buildParams(cnpj, startDate, endDate, page, status) {
  return {
    cnpj: cnpj,
    startDate: startDate,
    endDate: endDate,
    page: page,
    pageSize: 100,
    status: status,
  }
}

export async function tryCallSalesApi(cnpj, startDate, endDate, page, status, items) {
  const params = buildParams(cnpj, startDate, endDate, page, status)

  return await callSalesApi(params)
    .then(salesResponse => {
      if (salesResponse) {
        const salesByStatus = buildSalesStatusResponse(salesResponse.data.salesByStatus)
        buildItemsResponse(salesResponse.data.sales, items)

        return {
          items: items,
          status: salesByStatus,
          totalSales: (salesResponse.data.totalSales).toFixed(2),
          qtySales: salesResponse.data.qtySales,
          avgTickeg: (salesResponse.data.avgTicket).toFixed(2)
        }
      }
    })
}

export function buildItemsResponse(sales, items) {
  sales.map(sale => {
    return items.push({
      date: sale.date ? dateFormatter(sale.date) : 'Não definida',
      number: sale.invoiceId,
      clientName: sale.personName,
      orderTotalValue: `R$ ${ (sale.totalValue).toFixed(2) }`,
      taxPercentValue: sale.taxPercent,
      toPay: `R$ ${ (sale.taxValue).toFixed(2) }`,
      status: sale.canceled == STATUS.CANCELADO.id ? STATUS.CANCELADO.description : STATUS.CONCRETIZADO.description,
      paymentDate: sale.invoiceDate ? dateFormatter(sale.invoiceDate) : 'Não definida',
    })
  })

  return items
}

export function buildSalesStatusResponse(saleStatuses) {
  const qtyPerStatus = new Array(2)

  saleStatuses.map(saleStatus => {
    if (saleStatus.status == STATUS.CANCELADO.description)
      qtyPerStatus[1] = saleStatus.qtySales
    else
      qtyPerStatus[0] = saleStatus.qtySales
  })

  for (let position = 0; position < 2; position++)
    qtyPerStatus[position] = qtyPerStatus[position] == undefined ? 0 : qtyPerStatus[position]

  return qtyPerStatus
}

export async function onChange(isDateChange) {
  this.page = 1
  this.dataInicial = moment(this.dataInicial).format('YYYY-MM-DD 00:00')
  this.dataFinal = moment(this.dataFinal).format('YYYY-MM-DD 23:59')

  const salesApiResponse = await tryCallSalesApi(this.cnpj, this.dataInicial, this.dataFinal, this.page, this.status.toString(), new Array())

  if (isDateChange && !salesApiResponse.status.includes(undefined))
    this.series = checkIfHasNoStatus(salesApiResponse.status)

  this.items = salesApiResponse.items
  this.avgTicket = salesApiResponse.avgTickeg
  this.qtySales = salesApiResponse.qtySales
  this.totalSales = salesApiResponse.totalSales
}

export async function onChangeInitialDate(date) {
  await this.changeInitialDate(date)
  await this.onChange(true)
}

export async function onChangeEndDate(date) {
  await this.changeFinalDate(date)
  await this.onChange(true)
}

export async function infinitePagination() {
  window.onscroll = async () => {
    let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight

    if (bottomOfWindow) {
      this.page++
      const salesApiResponse = await tryCallSalesApi(this.cnpj, this.dataInicial, this.dataFinal, this.page, this.status.toString(), this.items)

      this.items = salesApiResponse.items
    }

    return this.page
  }
}

function checkIfHasNoStatus(status) {
  if (status[0] == 0 && status[1] == 0) {
    status[0] = undefined
    status[1] = undefined
  }

  return status
}